export default __webpack_public_path__ + "static/media/homeImage.9e65f5d7.jpg";